(function () {
  const initCollapsibleContent = () => {
    $(".collapsible-content__toggle")
      .unbind("click")
      .on("click", function () {
        const parent = $(this).parent();

        if (!parent.hasClass("active")) {
          parent
            .siblings(".collapsible-content__item.active")
            .removeClass("active");
          parent.addClass("active");
          $(this)
            .closest(".collapsible-content__items")
            .find(".collapsible-content__answer")
            .stop()
            .slideUp(300);
          $(this).next().stop().slideDown(300);
        } else {
          parent.removeClass("active");
          $(this).next().stop().slideUp(300);
        }
      });
  };

  document.addEventListener("shopify:section:load", function () {
    initCollapsibleContent();
  });

  initCollapsibleContent();

  if (!customElements.get("tracking-form")) {
    customElements.define(
      "tracking-form",
      class TrackingForm extends HTMLElement {
        constructor() {
          super();

          this.formEl;
        }

        connectedCallback() {
          this._init();
        }

        _init() {
          this.formEl = this.querySelector(".tracking-form__form");

          this.formEl.addEventListener(
            "submit",
            this.handleFormSubmission.bind(this),
          );
        }

        handleFormSubmission(e) {
          e.preventDefault();
          const formData = new FormData(this.formEl);
          const trackingNumber = formData.get("tracking_number");
          const courier = formData.get("courier");

          const trackingLink = this.createTrackingLink(trackingNumber, courier);
          this.redirectUserToTracking(trackingLink);
        }

        createTrackingLink(trackingNumber, courier) {
          let trackingLink = courier + trackingNumber;

          if (courier.includes("dhl")) {
            trackingLink = trackingLink + "&submit=1";
          }

          return trackingLink;
        }

        redirectUserToTracking(trackingLink) {
          window.open(trackingLink, "_blank").focus();
        }
      },
    );
  }
})();
